import styled from 'styled-components'
import FormInputContainerBase from '../shared/styles/FormInputContainerBase.js'

const StyledPhoneNumber = styled(FormInputContainerBase)`
	>div {
		display: block;
		>div {
			margin-bottom: unset !important;	
		}
		>div:first-of-type {
			width: 69px;
			min-width: unset;
		}
		>div:last-of-type {
			width: 211px;
			margin-right: unset !important;	
		}
	}
`

export default StyledPhoneNumber